export const map = {
  T600: {
    // font-size 40px / 32px
    // line-height 52px / 41.6px/42px
    xl: {
      fontSize: '--st-dt-text-size-900' /* 2.5rem */,
      lineHeight: '--st-dt-text-lineHeight-800' /* 1.3 */
    },
    l: {
      fontSize: '--st-dt-text-size-900' /* 2.5rem */,
      lineHeight: '--st-dt-text-lineHeight-800' /* 1.3 */
    },
    m: {
      fontSize: '--st-dt-text-size-800' /* 2rem */,
      lineHeight: '--st-dt-text-lineHeight-700' /* 1.3 */
    },
    s: {
      fontSize: '--st-dt-text-size-800' /* 2rem */,
      lineHeight: '--st-dt-text-lineHeight-700' /* 1.3 */
    }
  },
  T500: {
    // 32px / 28px
    // 41.6px/42px / 36.4px/36px
    xl: {
      fontSize: '--st-dt-text-size-800' /* 2rem */,
      lineHeight: '--st-dt-text-lineHeight-700' /* 1.3 */
    },
    l: {
      fontSize: '--st-dt-text-size-800' /* 2rem */,
      lineHeight: '--st-dt-text-lineHeight-700' /* 1.3 */
    },
    m: {
      fontSize: '--st-dt-text-size-700' /* 1.75rem */,
      lineHeight: '--st-dt-text-lineHeight-600' /* 1.3 */
    },
    s: {
      fontSize: '--st-dt-text-size-700' /* 1.75rem */,
      lineHeight: '--st-dt-text-lineHeight-600' /* 1.3 */
    }
  },
  T400: {
    // 24px / 22px
    // 31.2px/31px / 28.6px/29px
    xl: {
      fontSize: '--st-dt-text-size-600' /* 1.5rem */,
      lineHeight: '--st-dt-text-lineHeight-500' /* 1.3 */
    },
    l: {
      fontSize: '--st-dt-text-size-600' /* 1.5rem */,
      lineHeight: '--st-dt-text-lineHeight-500' /* 1.3 */
    },
    m: {
      fontSize: '--st-dt-text-size-500' /* 1.375rem */,
      lineHeight: '--st-dt-text-lineHeight-400' /* 1.3 */
    },
    s: {
      fontSize: '--st-dt-text-size-500' /* 1.375rem */,
      lineHeight: '--st-dt-text-lineHeight-400' /* 1.3 */
    }
  },
  T300: {
    // 20px / 18px
    // 30px/29px / 27px
    xl: {
      fontSize: '--st-dt-text-size-400' /* 1.25rem */,
      lineHeight: '--st-dt-text-lineHeight-400' /* 1.5 */
    },
    l: {
      fontSize: '--st-dt-text-size-400' /* 1.25rem */,
      lineHeight: '--st-dt-text-lineHeight-400' /* 1.5 */
    },
    m: {
      fontSize: '--st-dt-text-size-300' /* 1.125rem */,
      lineHeight: '--st-dt-text-lineHeight-300' /* 1.5 */
    },
    s: {
      fontSize: '--st-dt-text-size-300' /* 1.125rem */,
      lineHeight: '--st-dt-text-lineHeight-300' /* 1.5 */
    }
  },
  T200: {
    // 16px
    // 24px
    xl: {
      fontSize: '--st-dt-text-size-200' /* 1rem */,
      lineHeight: '--st-dt-text-lineHeight-200' /* 1.5 */
    },
    l: {
      fontSize: '--st-dt-text-size-200' /* 1rem */,
      lineHeight: '--st-dt-text-lineHeight-200' /* 1.5 */
    },
    m: {
      fontSize: '--st-dt-text-size-200' /* 1rem */,
      lineHeight: '--st-dt-text-lineHeight-200' /* 1.5 */
    },
    s: {
      fontSize: '--st-dt-text-size-200' /* 1rem */,
      lineHeight: '--st-dt-text-lineHeight-200' /* 1.5 */
    }
  },
  T100: {
    // 14px
    // 21px
    xl: {
      fontSize: '--st-dt-text-size-100' /* 0.875rem */,
      lineHeight: '--st-dt-text-lineHeight-100' /* 1.5 */
    },
    l: {
      fontSize: '--st-dt-text-size-100' /* 0.875rem */,
      lineHeight: '--st-dt-text-lineHeight-100' /* 1.5 */
    },
    m: {
      fontSize: '--st-dt-text-size-100' /* 0.875rem */,
      lineHeight: '--st-dt-text-lineHeight-100' /* 1.5 */
    },
    s: {
      fontSize: '--st-dt-text-size-100' /* 0.875rem */,
      lineHeight: '--st-dt-text-lineHeight-100' /* 1.5 */
    }
  },
  T50: {
    // 12px
    // 18px
    xl: {
      fontSize: '--st-dt-text-size-50' /* 0.75rem */,
      lineHeight: '--st-dt-text-lineHeight-50' /* 1.5 */
    },
    l: {
      fontSize: '--st-dt-text-size-50' /* 0.75rem */,
      lineHeight: '--st-dt-text-lineHeight-50' /* 1.5 */
    },
    m: {
      fontSize: '--st-dt-text-size-50' /* 0.75rem */,
      lineHeight: '--st-dt-text-lineHeight-50' /* 1.5 */
    },
    s: {
      fontSize: '--st-dt-text-size-50' /* 0.75rem */,
      lineHeight: '--st-dt-text-lineHeight-50' /* 1.5 */
    }
  }
};
export const fontSizePropAdapter = function (value) {
  let breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'l';
  const fontToken = map[value];
  if (!fontToken) {
    return undefined;
  }
  return "var(".concat(fontToken[breakpoint].fontSize, ")");
};
export const lineHeightPropAdapter = function (value) {
  let breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'l';
  const fontToken = map[value];
  if (!fontToken) {
    return undefined;
  }
  return "var(".concat(fontToken[breakpoint].lineHeight, ")");
};
export const map2Tokens = legacyThemeProperty => {
  const cssVariables = Object.entries(legacyThemeProperty).reduce((cssVariables, _ref) => {
    let [sizeKey, sizeKeyValues] = _ref;
    const sizeCSSVariables = Object.entries(sizeKeyValues).reduce((sizeCSSVariables, _ref2) => {
      let [breakpointKey, breakpointValues] = _ref2;
      const cssVariableFontSize = breakpointKey !== '' ? map[sizeKey][breakpointKey]['fontSize'] : undefined;
      const cssVariableLineHeight = breakpointKey !== '' ? map[sizeKey][breakpointKey]['lineHeight'] : undefined;
      const fontSizeValue = breakpointValues['fontSize'];
      const lineHeightValue = breakpointValues['lineHeight'];
      return {
        ...sizeCSSVariables,
        ...(cssVariableFontSize && {
          [cssVariableFontSize]: fontSizeValue
        }),
        ...(cssVariableLineHeight && {
          [cssVariableLineHeight]: lineHeightValue
        })
      };
    }, {});
    return {
      ...cssVariables,
      ...sizeCSSVariables
    };
  }, {});
  return cssVariables;
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  const legacyThemeObject = Object.entries(legacyThemeProperty).reduce((legacyThemeObject, _ref3) => {
    let [sizeKey, sizeValues] = _ref3;
    const sizeValuesObject = Object.entries(sizeValues).reduce((sizeValuesObject, _ref4) => {
      let [breakpointKey] = _ref4;
      const cssVariableFontSize = breakpointKey !== '' ? map[sizeKey][breakpointKey]['fontSize'] : undefined;
      const cssVariableLineHeight = breakpointKey !== '' ? map[sizeKey][breakpointKey]['lineHeight'] : undefined;
      const fontSizeTokenValue = cssVariableFontSize && tokens[':root'] ? tokens[':root'][cssVariableFontSize] : undefined;
      const lineHeightTokenValue = cssVariableLineHeight && tokens[':root'] ? tokens[':root'][cssVariableLineHeight] : undefined;
      return {
        ...sizeValuesObject,
        [breakpointKey]: {
          fontSize: fontSizeTokenValue,
          lineHeight: lineHeightTokenValue
        }
      };
    }, {});
    return {
      ...legacyThemeObject,
      [sizeKey]: sizeValuesObject
    };
  }, {});
  return {
    ...legacyThemeProperty,
    ...legacyThemeObject
  };
};